export default "__VITE_ASSET__ClZE3adP__"